/**
 * Service: priceApi
 */
angular.module('acme.common.service.priceApi', [
    'acme.common.factory.QueryStringBuilder',
    'acme.common.factory.apiVersion'
  ])
.service('PriceApiService', [ '$http', 'QueryStringBuilderFactory', 'ApiVersionFactory', function ($http, QueryStringBuilderFactory, ApiVersionFactory) {
  return {

    service: '',

    init: function (endpoint) {
      this.service = endpoint + '/price';
      this.lists.service = this.service;
      this.types.service = this.service;
      return this;
    },

    types: {
      service: '',

      search: function(props) {
        var qs,
            q = '',
            av = new ApiVersionFactory();

        if (props) {
          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['search', 'page', 'pageSize', 'sortDirection', 'sortField', 'totalItems']
            }
          });
          q = qs.query;
        }

        if (q.indexOf('search=') < 0) {
          q += '&search=';
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/person/types/names' + q, version: 'v2' })
        });
      },

      /**
       * Lists all person types
       *
       * Accepts:
       *
       * {
       *   groups: (Optional) {boolean}
       *   inactive: (Optional) {boolean}
       * }
       *
       * @param props
       * @returns {*}
       */
      list: function (props) {
        var q = '';

        if (props) {
          if (props.inactive) {
            props.includeInactive = true;
          }

          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['types', 'includeInactive', 'pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') + '/person/types' + q
        });
      },

      /**
       * Creates a new person type
       *
       * Accepts:
       *
       * {
       *   id: {String},
       *   name: {String},
       *   description: {String},
       *   active: {boolean},
       *   group: {boolean},
       *   defaultPrice: {float},
       *   displayOrder: {Number}
       * }
       *
       * @param props
       * @returns {*}
       */
      create: function (props) {
        return $http({
            method: 'post',
            url: this.service + '/person/types',
            data: {
              name: props.name,
              description: props.description,
              active: props.active,
              type: props.type,
              defaultPrice: props.defaultPrice,
              displayOrder: props.displayOrder,
              children: props.children
            }
          }
        );
      },

      /**
       * Updates a new person type
       *
       * Accepts:
       *
       * {
       *   id: {String},
       *   name: {String},
       *   description: {String},
       *   active: {boolean},
       *   group: {boolean},
       *   defaultPrice: {float},
       *   displayOrder: {Number}
       * }
       *
       * @param props
       * @returns {*}
       */
      update: function (props) {
        return $http({
            method: 'put',
            url: this.service + '/person/types',
            data: {
              id: props.id,
              name: props.name,
              description: props.description,
              active: props.active,
              type: props.type,
              defaultPrice: props.defaultPrice,
              displayOrder: props.displayOrder,
              children: props.children
            }
          }
        );
      },

      /**
       * Removes a person type
       *
       * @param id {String}
       * @returns {*}
       */
      remove: function (id) {
        return $http({
            method: 'delete',
            url: this.service + '/person/types/' + id
          }
        );
      }

    },

    lists: {

      service: '',

      list: function (props) {
        var q = '';

        if (props) {
          if (props.inactive) {
            props.includeInactive = true;
          }

          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') + '/lists' + q
        });
      },

      /**
       * Creates a new price list
       *
       * Accepts:
       * {
       *   name: {String},
       *   description: {String},
       *   effectiveStartTime: {Date ISO8601},
       *   effectiveEndTime: {Date ISO8601},
       *   priceListType: {String} membership | event
       *   prices: [{
       *     personType: {
       *       id: {String},
       *       name: {String},
       *       description: {String},
       *       active: {boolean},
       *       group: {boolean},
       *       defaultPrice: {float},
       *       displayOrder: {Number}
       *     },
       *     price: {float},
       *     primePrice: {float}
       *   }]
       * }
       *
       * @param props
       * @returns {*}
       */
      create: function (props) {
        return $http({
            method: 'post',
            url: this.service + '/lists',
            data: {
              name: props.name,
              description: props.description,
              effectiveStartTime: props.effectiveStartTime,
              effectiveEndTime: props.effectiveEndTime,
              priceListType: props.priceListType,
              prices: props.prices
            }
          }
        );
      },

      update: function (props) {
        return $http(
          {
            method: 'put',
            url: this.service + '/lists',
            data: {
              id: props.id,
              name: props.name,
              description: props.description,
              effectiveStartTime: props.effectiveStartTime,
              priceListType: props.priceListType,
              prices: props.prices
            }
          });
      },

      detail: function (id) {
        return $http(
          {
            method: 'get',
            url: this.service + '/lists/' + id
          });
      },

      remove: function (id) {
        return $http({
          method: 'delete',
          url: this.service + '/lists/' + id
        });
      }
    }

  };
}]);